let timelineElements = [
    {
        id: 1,
        title: "Software Developer",
        location: "Remote, Bengaluru",
        description:
            [
                "Led the development of React Native applications, resulting in improved user engagement.",
                "Practiced agile and sprint practices to efficiently manage project development and meet deadlines.",
                "Integrated DotNet APIs and utilized PostgreSQL and Azure for efficient deployments"
            ],
        date: "Feb 2024 - present",
        icon: "krewbee",
    },
    {
        id: 4,
        title: "SDE Intern",
        location: "Remote, India",
        description:
            [
                "Developed REST APIs using Node.js, Express, and MongoDB, enhancing system performance.",
                "Integrated webhooks from Booking.com and Staah, increasing system reliability.",
                "Part of a feature-building team responsible for enhancing product functionality."
            ],
        date: "May 2023 - Jul 2023",
        icon: "simulas",
    },
    {
        id: 2,
        title: "Full Stack Developer",
        location: "Nadiad, Gujarat",
        description:
            [
                "Led team in building new website, resulting in 30% sales increase.",
                "Implemented automated deployment from GitHub workflows, reducing deployment time from 5-10 minutes per deployment to near-instantaneous, enhancing efficiency and enabling rapid iteration."
            ],
        date: "Apr 2022 - Present",
        icon: "malgadi",
    },
    {
        id: 3,
        title: "Technical Lead",
        location: "Nadiad, Gujarat",
        description:
            [
                "Led planning and execution of technology events, resulting in a 20% increase in event attendance.",
                "Managed a tech team of 10 members, ensuring successful implementation of tech initiatives and events."
            ],
        date: "Sep 2022 - Present",
        icon: "csi",
    },
];

export default timelineElements;